// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getContextTeamBadges: () => Record<string, BadgeInfo> = memoize(
    (): Record<string, BadgeInfo> => ({
        threedaychallengechampionbadge: {
            description: t`Three-Day Math Points Challenge`,
            extendedDescription: t`Over a specific 3-day challenge period, earn 7,000 energy points doing math problems`,
        },
        threedayteamchallengechampionbadge: {
            description: t`Three-Day Math Points Team Challenge`,
            extendedDescription: t`Over a specific 3-day challenge period, earn a total of 35,000 energy points as a team doing math problems`,
        },
        teambetachampionbadge: {
            description: t`Team Beta: Challenge Champion`,
            extendedDescription: t`Earn (30,000 * number of team members) points as a team within a week`,
        },
        dogfoodteambadge: {
            description: t`Teams Dogfood Participant`,
            extendedDescription: t`Help test the Teams feature as a Khan Academy team member`,
        },
        teambetateammatebadge: {
            description: t`Team Beta: Challenge Teammate`,
            extendedDescription: t`Participate in the Team Beta Experiment`,
        },
    }),
);
